import { defineMigrations } from "@supersig/store";
/** @public */ export const drawerNodeProps = {};
/** @internal */ export const drawerNodeMigrations = defineMigrations({});
export const DrawerNodeInfo = {
    migrations: drawerNodeMigrations,
    props: drawerNodeProps,
    meta: {}
};
